import React, { useState } from 'react';
import { Alert, Button, Form, Modal, Table } from 'react-bootstrap';
import { machiningFields } from './machiningFields';
import { CategoryDeleteButton } from './CategoryDeleteButton';

export function AssetCategoryManager({ kind, categories, saving, error, onClose, onSave, onDelete }) {
    const [editing, setEditing] = useState(null);
    const [description, setDescription] = useState('');
    const [validation, setValidation] = useState('');

    async function deleteCategory(category) {
        const deleted = await onDelete(category);

        if (deleted && editing?.id === category.id) {
            setEditing(null);
            setDescription('');
            setValidation('');
        }
    }

    async function submit(event) {
        event.preventDefault();

        if (!description.trim()) {
            setValidation('Category name is required.');
            return;
        }

        if (await onSave(editing, { description: description.trim() })) {
            setDescription('');
            setEditing(null);
            setValidation('');
        }
    }
    
    return (
        <Modal
            show
            onHide={saving ? undefined : onClose}
            backdrop={saving ? 'static' : true}
            keyboard={!saving}
            aria-labelledby="category-manager-title"
        >
            <Modal.Header closeButton={!saving}>
                <Modal.Title id="category-manager-title">
                    {machiningFields[kind].categoryTitle}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error?.message ? <Alert variant="danger">{error.message}</Alert> : null}
                <Table size="sm">
                    <thead>
                        <tr>
                            <th>No.</th>
                            <th>Name</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {categories.map((category) => (
                            <tr key={category.id}>
                                <td>{category.category ?? '…'}</td>
                                <td>{category.description}</td>
                                <td>
                                    <div className="d-flex align-items-start gap-2">
                                        <Button
                                            size="sm"
                                            variant="outline-primary"
                                            disabled={saving || category.id === 'pending'}
                                            aria-label={`Rename ${category.description}`}
                                            onClick={() => {
                                                setEditing(category);
                                                setDescription(category.description);
                                                setValidation('');
                                            }}
                                        >
                                            Rename
                                        </Button>
                                        <CategoryDeleteButton
                                            category={category}
                                            saving={saving}
                                            onDelete={deleteCategory}
                                        />
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
                <Form onSubmit={submit} noValidate>
                    <Form.Group controlId="asset-category-name" className="mb-3">
                        <Form.Label>Category name</Form.Label>
                        <Form.Control
                            value={description}
                            maxLength={200}
                            disabled={saving}
                            onChange={(event) => {
                                setDescription(event.target.value);
                                setValidation('');
                            }}
                        />
                        {validation || error?.fields?.description ? (
                            <div role="alert" className="invalid-feedback d-block">
                                {validation || error.fields.description}
                            </div>
                        ) : null}
                    </Form.Group>
                    <div className="d-flex gap-2">
                        <Button type="submit" disabled={saving}>
                            {editing ? 'Save category' : 'Add category'}
                        </Button>
                        {editing ? (
                            <Button
                                variant="secondary"
                                disabled={saving}
                                onClick={() => {
                                    setEditing(null);
                                    setDescription('');
                                }}
                            >
                                Cancel rename
                            </Button>
                        ) : null}
                    </div>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" disabled={saving} onClick={onClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
